export default __webpack_public_path__ + "static/media/login2.a7f560f6.svg";